export enum CdvType {
  Cloud = "Cloud",
  Tier = "Tier",
  InstallURL = "installURL",
  CatalogTypeName = "Catalog Type Name",
  CatalogTypePermittedEmails = "CatalogTypePermittedEmails",
}
